import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzMicroactionModule } from '@blk/daisy/combinations/microactions';
import { DzNotificationsModule } from '@blk/daisy/combinations/notifications';
import { SearchModule } from '@blk/daisy/combinations/search';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AdvisoryFeeModule } from '@ddt-web/advisory-fee';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { CwpModule } from '@ddt-web/cwp';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';
import { DropdownFiltersModule, FamiliesModule, HighlightedFiltersModule } from '@ddt-web/models-browsing';
import { PerformanceModule } from '@ddt-web/performance';
import { faCaretDown, faFileExcel, faFilter, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import { MiniCompareBarModule } from '../mini-compare-bar';
import { FindCompareComponent } from './find-compare.component';

@NgModule({
	declarations: [
		FindCompareComponent
	],
	imports: [
		AnalyticsModule,
		CommonModule,
		RouterModule.forChild([{ path: '', component: FindCompareComponent }]),
		CwpNgFrameworkModule,
		DataServiceModule,
		DisclosureModule,
		FamiliesModule,
		SharedModule,
		CoreModule,
		DzButtonModule,
		HighlightedFiltersModule,
		DropdownFiltersModule,
		DzIconModule.withIcons(faCaretDown, faFileExcel, faTimesCircle, faFilter, faTimes),
		MiniCompareBarModule,
		CwpModule,
		DzMicroactionModule,
		DzNotificationsModule,
		PerformanceModule,
		SearchModule,
		AdvisoryFeeModule
	]
})
export class FindCompareModule { }
